import { OpArgType } from '@memoraiz/api-client';
import { SdkResource } from './common';

export const feedback = SdkResource.from((client) => ({
  create: (data: OpArgType<'/widgets/feedbacks', 'post'>) =>
    client
      .POST('/widgets/feedbacks', { body: data })
      .then(({ data: response }) => {
        if (!response) {
          throw new Error('Invalid response');
        }
        return response.data;
      }),
}));
